import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const CampaignNotificationsRoutes: Routes = [
  {
    path: "campaign-notifications",
    loadComponent: () =>
      import("./campaign-notifications/campaign-notifications.component").then(
        (m) => m.CampaignNotificationsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./campaign-notifications-list/campaign-notifications-list.component").then(
            (m) => m.CampaignNotificationsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./campaign-notifications-form/campaign-notifications-form.component").then(
            (m) => m.CampaignNotificationsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./campaign-notifications-form/campaign-notifications-form.component").then(
            (m) => m.CampaignNotificationsFormComponent,
          ),
      },
    ],
  },
];
